import { useState } from "react"

export const Statements = ({ statements }) => {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <section className="p-8 flex flex-col gap-3" id="statements">
            <div className="flex justify-between border-b border-dashed">
                <h2 className="text-3xl">Statements</h2>
                <button onClick={() => setIsOpen(!isOpen)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="12.828" viewBox="0 0 22.828 12.828">
                        <g transform="translate(-639.185 -729.386)">
                            <line x1="10" y2="10" transform="translate(650.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                            <line x2="10" y2="10" transform="translate(640.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                        </g>
                    </svg>
                </button>
            </div>
            {isOpen && (
                <article className="border-[1px] border-[black]">
                    <div>
                        <p className="p-3 font-bold border-b text-xl">Purpose</p>
                        <span className="p-3">{statements.purpose}</span>
                    </div>
                    <div>
                        <p className="p-3 font-bold border-b border-t text-xl">Vision</p>
                        <span className="p-3">{statements.vision}</span>
                    </div>
                    <div>
                        <p className="p-3 font-bold border-b border-t text-xl">Positioning</p>
                        <span className="p-3">{statements.positioning}</span>
                    </div>
                </article>
            )}
        </section>
    )
}